export function logosSlider() {
    const $slider = $(".logos-slider");
    const itemCount = $slider.find(".slide, .item, .logo").length; 
    const isDesktop = window.innerWidth >= 1200; 
    console.log(itemCount, isDesktop);
    if (!isDesktop || (itemCount >= 8 && isDesktop)) {
        $slider.infiniteslide({
            direction: "left",
            speed: 30,
            pauseonhover: true,
            responsive: true,
            clone: 3
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js